var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6" }, [
            _c("div", { staticClass: "m-b-xs-20" }, [
              _c(
                "div",
                { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                [
                  _c(
                    "div",
                    { staticClass: "ak-panel__header ak-panel__header--small" },
                    [
                      _c("div", { staticClass: "ak-panel__title" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("Lid")) +
                            "\n                            "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ak-panel__body ak-panel__body--small reading",
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.request.user.card.name)),
                      ]),
                      _vm._v(
                        " (" + _vm._s(_vm.request.user.card.organisation) + ") "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "fa fa-envelope" }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "mailto:" + _vm.request.user.card.email,
                          },
                        },
                        [_vm._v(_vm._s(_vm.request.user.card.email))]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "fa fa-home" }),
                      _vm._v(" " + _vm._s(_vm.request.user.card.address)),
                      _c("br"),
                      _vm._v(" "),
                      _vm._l(_vm.request.user.card.phones, function (phone) {
                        return [
                          phone.type === "mobile"
                            ? _c("span", { staticClass: "fa fa-mobile-phone" })
                            : _c("span", { staticClass: "fa fa-phone" }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(phone.phone) +
                              " "
                          ),
                          _c("br"),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6" }, [
            _c("div", { staticClass: "m-b-xs-20" }, [
              _c(
                "div",
                { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "ak-panel__header ak-panel__header--warning ak-panel__header--small",
                    },
                    [
                      _c("div", { staticClass: "ak-panel__title" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("Vorige attesten")) +
                            "\n                            "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ak-panel__body ak-panel__body--small reading",
                    },
                    [
                      _vm.requests.length
                        ? _c(
                            "table",
                            { staticClass: "ak-table ak-panel__table" },
                            [
                              _c("thead", [
                                _c("tr", { staticClass: "ak-table-row" }, [
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                             " +
                                        _vm._s(_vm.$t("Datum")) +
                                        "\n                                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                             " +
                                        _vm._s(_vm.$t("Merk")) +
                                        "\n                                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                             " +
                                        _vm._s(_vm.$t("Dealer")) +
                                        "\n                                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                             " +
                                        _vm._s(_vm.$t("Goedgekeurd")) +
                                        "\n                                        "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.requests, function (userRequest) {
                                  return _c(
                                    "tr",
                                    {
                                      key: userRequest.hashId,
                                      staticClass: "ak-table-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                userRequest.dateCreatedForDisplay
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(userRequest.brandName) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                userRequest.certificateName
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(userRequest.isApproved) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
            [
              _c(
                "ak-form",
                _vm._g(
                  {
                    attrs: {
                      bundle: _vm.bundle,
                      definition: _vm.definition,
                      objectId: _vm.objectId,
                      relationString: _vm.relationString,
                    },
                    on: {
                      save: _vm.backToGrid,
                      cancel: function ($event) {
                        return _vm.attemptClose(_vm.close)
                      },
                    },
                  },
                  _vm.$listeners
                )
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ak-loader", { attrs: { size: "large", loading: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }